// extracted by mini-css-extract-plugin
export default {"rating":"vM-z","numberOfStars":"wM-z","count":"xM-z","barGraphSpacing":"yM-z","barGraph":"zM-z"};